define([
    'lodash',
    'gridComponent/core/enums'
], function (_, Enums) {
    'use strict';

    function updateRow(delta) {
        return {
            forEachNode: [
                function (rowNode) {
                    if (Number(delta.index) === Number(rowNode.id)) {
                        rowNode.setData(delta.data);
                    }
                }
            ]
        };
    }

    const rowModification = {};
    rowModification[Enums.RowModification.UPDATE] = updateRow;
    Object.freeze(rowModification);

    return function (delta) {
        return rowModification[delta.op](delta);
    };
});
